import { create } from 'zustand'
import type { UploadQueueItem, UploadStatus } from '@/types'

interface UploadState {
  items:      UploadQueueItem[]
  setItems:   (items: UploadQueueItem[]) => void
  addItem:    (item: UploadQueueItem) => void
  updateItem: (id: string, patch: Partial<UploadQueueItem>) => void
  removeItem: (id: string) => void
  clearDone:  () => void
  // Derived
  activeCount: () => number
  errorCount:  () => number
}

export const useUploadStore = create<UploadState>((set, get) => ({
  items: [],

  setItems:  (items)        => set({ items }),
  addItem:   (item)         => set(s => ({ items: [item, ...s.items] })),
  updateItem: (id, patch)   => set(s => ({
    items: s.items.map(i => i.id === id ? { ...i, ...patch } : i),
  })),
  removeItem: (id)          => set(s => ({ items: s.items.filter(i => i.id !== id) })),
  clearDone:  ()            => set(s => ({ items: s.items.filter(i => i.status !== 'done') })),

  activeCount: () => {
    const active: UploadStatus[] = ['queued', 'uploading', 'saving', 'routing', 'retrying']
    return get().items.filter(i => active.includes(i.status)).length
  },
  errorCount: () => get().items.filter(i => i.status === 'error').length,
}))
